import { put, takeEvery } from "redux-saga/effects";
import messagePopup from "../../../../utils/messagePopup";
import history from "../../../../services/history";
import { fetchGraphMethod } from "../../../../services/httpService";

/* ======================================= Actions Type ==========================================*/
export const actionType = {
  COLLEGE_ACADEMICS_LIST_START: "COLLEGE_ACADEMICS_LIST_START",
  COLLEGE_ACADEMICS_SUCCESS: "COLLEGE_ACADEMICS_SUCCESS",
  COLLEGE_ACADEMICS_FAILURE: "COLLEGE_ACADEMICS_FAILURE",
};

/* ======================================= Actions Creator ==========================================*/

export const collegeAcademicsListStart = (data) => ({
  type: actionType.COLLEGE_ACADEMICS_LIST_START,
  payload: data,
});

export const collegeAcademicsSuccess = (data) => ({  
    type: actionType.COLLEGE_ACADEMICS_SUCCESS,
    payload: data,
});
  
export const collegeAcademicsFailure = (data) => ({
    type: actionType.COLLEGE_ACADEMICS_FAILURE,
    payload: data
});

/* ======================================= Reducer ==========================================*/
const INIT_STATE = {
  loading: false,
  data: null,
  error: null,
};
export default function collegeAcademicsReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case actionType.COLLEGE_ACADEMICS_LIST_START:
      return { ...state, loading: true };
    
    case actionType.COLLEGE_ACADEMICS_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null };

    case actionType.COLLEGE_ACADEMICS_FAILURE:
      return { ...state, loading: false, data: null, error: action.payload };

    default:
      return { ...state };
  }
}

/* ======================================= Side Effects ==========================================*/


function* getCollegeAcademicsSaga(action) {
    try {
        const response = yield fetchGraphMethod(action.payload.query,action.payload.variables,true);
        if(response.status === 200){
            const allCollegeAcademics = response.data?.data?.allAcademiccollegedetails?.Academiccollegedetails;

            yield put(collegeAcademicsSuccess(allCollegeAcademics));
        } else {
          messagePopup('', 'College Academics Data Failed', 'error');
          yield put(collegeAcademicsFailure('Failed, Error occured'))
        }
       } catch (error) {
         messagePopup('', 'College Academics Data Failed', 'error');
         yield put(collegeAcademicsFailure('Failed, Error occured'))
       }
}

export function* watchCollegeAcademicsSaga() {
  yield takeEvery(actionType.COLLEGE_ACADEMICS_LIST_START, getCollegeAcademicsSaga);
}

